import { render } from "./PDFParadigmInspection.vue?vue&type=template&id=5a2061f2&ts=true"
import script from "./PDFParadigmInspection.vue?vue&type=script&lang=ts"
export * from "./PDFParadigmInspection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__